import React from "react";
import "./ColorButtons.css"

function ColorButtons() {
  return (
    <div className="color_buttons">
      <button className="green_btn color_btn_holder">Green</button>
      <button className="violet_btn color_btn_holder">Violet</button>
      <button className="red_btn color_btn_holder" >Red</button>
    </div>
  );
}

export default ColorButtons;